import React from 'react';
import { connect } from 'react-redux';
import { permIndices } from '../../Permissions';
import CollegePageContainer from '../Container/CollegePageContainer';
import CollegeJobListMain from './CollegeJobListMain';

const CollegeJobList = (props) => {
  const tabs = [
    {
      text: 'Calendar',
      pathname: '/CollegeCalendar',
    },
    {
      text: 'Job List',
      pathname: '/CollegeJobList',
      active: true,
    },
  ];

  return (
    <CollegePageContainer header='Job List' tabs={tabs} user={props.user}>
      <CollegeJobListMain
        user={props.user}
        institution={props.institution}
        campuses={props.campuses}
        classes={props.classes}
      />
    </CollegePageContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
    classes: state.college.classes,
    viewbookings: state.college.user.permissions
      ? state.college.user.permissions & (1 << permIndices.vi_book)
      : 1,
    editbookings: state.college.user.permissions
      ? state.college.user.permissions & (1 << permIndices.ed_book)
      : 1,
  };
}

export default connect(mapStateToProps)(CollegeJobList);
